import useLocalStorageState from './src/useLocalStorageState';
export default useLocalStorageState;
